<wk-icon-smartphone-sprite-pds3 />
<icon-pds3 name="wk-icon-smartphone" />
@if (cardModalService.currentCard()?.contactInformation?.cellPhone) {
    <span class="wk-cm__header__icon-text">{{ cardModalService.currentCard().contactInformation?.cellPhone }}</span>
}

<tooltip-pds3 position="bottom" mode="indicator" [openDelay]="600" [closeDelay]="50" targetSelector=".wk-cm__header__icon-smartphone">
    {{ "CardModal.CellPhone" | translate }}
</tooltip-pds3>
